export default {
  currentStep: state => state.currentStep,
  loading: state => state.loading,
  steps: state => state.steps,
  stepsNamesRoutes: state => state.stepsNamesRoutes,
  getInformation: state => state.information,
  getSegmentOptions: state => state.segmentOptions,
  getOrderConfig: state => state.orderConfig,
  getBiometryConfig: state => state.biometryConfig,
  getSecurityConfig: state => state.securityConfig
}
